import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Link from 'next/link';
import classNames from 'classnames';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import RestaurantGroupDropdown from './RestaurantGroupDropdown';
import GroupsDropdown from './GroupsDropdown';
import RightContent from './RightContent';
import { actions as appActions } from 'src/actions/app';
import { isGroupUserSelector, localeSelector } from 'src/selector/app';
import styles from './index.less';

const SmallLogo = `${process.env.ASSETS_PREFIX}/assets/logo_sm.png`;
const Logo = `${process.env.ASSETS_PREFIX}/assets/logo.png`;

const GlobalHeader = (props) => {
  const { isMobile, sideBarWidth, collapsed, showAvatar, showNavToggle = true } = props;
  const dispatch = useDispatch();
  const _locale_ = useSelector(localeSelector);
  const isGroup = useSelector(isGroupUserSelector);

  const toggle = () => {
    dispatch({
      type: appActions.changeLayoutCollapsed,
      payload: !collapsed,
    });
  };

  return (
    <div className={classNames(styles.header, styles.fixHeader)} style={{ left: collapsed ? 0 : sideBarWidth }}>
      <div className={styles.left}>
        {isMobile && (
          <Link href="/" key="logo" locale={_locale_}>
            <a>
              <span className={styles.logo}>
                <img src={SmallLogo} alt="logo" />
              </span>
            </a>
          </Link>
        )}
        {showNavToggle ? (
          <span className={styles.trigger} onClick={toggle}>
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </span>
        ) : (
          <div className={styles.restaurantLogo}>
            <Link href="/" key="logo" locale={_locale_}>
              <a>
                <img src={Logo} width="178" />
              </a>
            </Link>
          </div>
        )}
        {isGroup ? <GroupsDropdown /> : <RestaurantGroupDropdown />}
      </div>
      <RightContent showAvatar={showAvatar} />
    </div>
  );
};

export default GlobalHeader;
